<template>
  <base-container class="layout-row" ref="container" :isLoading="loading">
    <artisan-group
      title="检查资源"
      border
      style="height: 100%; width: 240px; background-color: #fff"
    >
      <el-tree
        :data="resTree"
        :props="defaultProps"
        @node-click="handleNodeClick"
        default-expand-all
        current-node-key="id"
        :expand-on-click-node="false"
      >
        <span style="flex: 1" slot-scope="{ node, data }">
          <span :class="data.id == resId ? 'color-primary' : ''">
            {{ node.label }}
          </span>
        </span>
      </el-tree>
    </artisan-group>
    <div
      style="
        flex: 1;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        margin: 0 5px;
        height: 100%;
      "
    >
      <artisan-group title="预约资源统计分析" border style="height: 100%">
        <div style="text-align: center">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            unlink-panels
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="dateChange"
          >
          </el-date-picker>
        </div>

        <div
          style="
            height: calc(100% - 60px);
            display: grid;
            grid-template-columns: 3fr 1fr 3fr;
            margin-top: 20px;
          "
        >
          <div
            id="rcs_bill_dept"
            style="height: 500px; width: auto; border: 1px solid #d7d7d7"
          ></div>
          <div
            style="
              font-weight: bold;
              margin-top: 170px;
              display: flex;
              justify-content: center;
            "
          >
            <div
              style="
                height: 150px;
                width: 150px;
                border-radius: 75px;
                border: 1px solid #d7d7d7;
                text-align: center;
                padding-top: 30px;
              "
            >
              <div style="font-size: 22px">{{ reserveTotal }}</div>
              <div style="font-size: 17px">预约总数</div>
            </div>
          </div>
          <div
            id="rcs_bill_clinic"
            style="height: 500px; width: auto; border: 1px solid #d7d7d7"
          ></div>
        </div>
      </artisan-group>
    </div>
  </base-container>
</template>

<script>
import { getAuthResource } from "@/api/jc/reserve";
import { buildTree, getClinicTypeLabel } from "@/util/util";
import moment from "moment";
import { getBillDeptSummary } from "@/api/jc/summary";
import * as echarts from "echarts";
import { data } from "jquery";
export default {
  data() {
    return {
      loading: false,
      defaultProps: {
        children: "children",
        label: "name",
        value: "id",
      },
      resources: [],
      resId: "",
      depts: [],
      dateRange: ["2025-04-01", moment().format("YYYY-MM-DD")],
      summaryData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    resTree() {
      let treeData = buildTree(this.resources);
      let roots = [];
      this.depts.forEach((c) => {
        let root = Object.assign({ children: [] }, c);
        root.children = treeData.filter((c) => c.deptId == root.id);
        roots.push(root);
      });
      return roots;
    },
    reserveTotal() {
      return this.summaryData
        .filter(
          (c) =>
            c.status == "ok" ||
            c.status == "sign" ||
            c.status == "check" ||
            c.status == "report"
        )
        .reduce((a, b) => (a += b.count), 0);
    },
    deptSummary() {
      let dataMap = new Map();
      let billTotal = 0;
      this.summaryData.forEach((c) => {
        billTotal += c.count;
        if (dataMap.has(c.billDeptId)) {
          let obj = dataMap.get(c.billDeptId);
          obj.count += c.count;
        } else {
          dataMap.set(c.billDeptId, {
            deptId: c.billDeptId,
            name: c.billDeptName,
            value: 0,
            count: c.count,
          });
        }
      });
      let dataArr = Array.from(dataMap.values()).sort(
        (a, b) => a.count - b.count
      );
      if (billTotal) {
        dataArr.forEach((c) => {
          c.value = Math.round((c.count / billTotal) * 100);
        });
      }

      return dataArr;
    },
  },
  created() {
    getAuthResource().then((res) => {
      this.resources = res.data.data;
      let dm = new Map();
      this.resources.forEach((c) => {
        if (!dm.has(c.deptId)) {
          dm.set(c.deptId, {
            id: c.deptId,
            name: c.deptName,
            type: "dept",
          });
        }
      });
      this.depts = dm.values();
    });
  },
  mounted() {
    this.loadData();
  },
  methods: {
    getClinicTypeLabel,
    loadData() {
      this.loading = true;
      getBillDeptSummary(this.dateRange[0], this.dateRange[1], this.resId)
        .then((res) => {
          this.loading = false;
          let { data } = res.data;
          this.summaryData = data;
          this.$nextTick(() => {
            this.buildBarTrend();
            this.buildPieTrend();
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleNodeClick(data) {
      if (!data.type) {
        this.resId = data.id;
        this.loadData();
      }
    },
    dateChange() {
      this.loadData();
    },
    buildBarTrend() {
      let docEl = document.getElementById("rcs_bill_dept");
      docEl.style.width = docEl.parentElement.style.width;
      let myChart = echarts.init(docEl);
      let chartOption = {
        title: {
          text: "开单科室统计分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : <b>{c}%</b>",
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          data: this.deptSummary.map((c) => c.name),
        },
        series: [
          {
            type: "bar",
            label: {
              show: true,
              position: "right",
              formatter:"{c}%"
            },
            data: this.deptSummary.map((c) => c.value),
          },
        ],
      };
      myChart.setOption(chartOption, true);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    buildPieTrend() {
      let clinicMap = new Map();
      this.summaryData.forEach((c) => {
        if (clinicMap.has(c.clinicType)) {
          let obj = clinicMap.get(c.clinicType);
          obj.value += c.count;
        } else {
          clinicMap.set(c.clinicType, {
            name: this.getClinicTypeLabel(c.clinicType),
            value: c.count,
          });
        }
      });
      let myChart = echarts.init(document.getElementById("rcs_bill_clinic"));
      let dataArr = Array.from(clinicMap.values());
      let chartOption = {
        title: {
          text: "患者来源统计分析",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : <b>{c}</b> ({d}%)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 10,
          top: 20,
          bottom: 20,
          data: dataArr.map((c) => c.name),
        },
        color: ["#909399", "#409EFF", "#67C23A", "#F70303", "#E6A23C", "green"],
        series: [
          {
            type: "pie",
            radius: "55%",
            label: {
              formatter: "{b} : {c} ({d}%)",
            },
            data: dataArr,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChart.setOption(chartOption, true);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
